export default {
  'releaseBillToPay.list.header.code': 'Código',
  'releaseBillToPay.list.header.installmentTag': 'Etiqueta',
  'releaseBillToPay.list.header.companies': 'Empresa',
  'releaseBillToPay.list.header.documentNumber': 'Nº documento',
  'releaseBillToPay.list.header.creditor': 'Credor',
  'releaseBillToPay.list.header.description': 'Descrição',
  'releaseBillToPay.list.header.documentType': 'Tp.Doc.',
  'releaseBillToPay.list.header.dueDate': 'Vencimento',
  'releaseBillToPay.list.header.situation': 'Situação',
  'releaseBillToPay.list.header.value': 'Valor',
  'releaseBillToPay.list.header.amountPaid': 'Valor pago',
  'releaseBillToPay.list.header.amountReceivable': 'Valor a receber',
  'releaseBillToPay.list.header.actions': 'Ações',

  'releaseBillToPay.domain.enums.situation_installment_payable.open': 'Aberta',
  'releaseBillToPay.domain.enums.situation_installment_payable.settled':
    'Liquidada',

  'releaseBillToPay.searchBar.create': 'Criar Nova Conta a Pagar',
  'releaseBillToPay.searchBar.settleMultipleInstallments':
    'Liquidar Parcelas Selecionadas',

  'release.form.company': 'Empresa',
  'release.form.creditor': 'Credor',
  'release.form.supplier': 'Fornecedor',
  'release.form.employee': 'Funcionário',
  'release.form.planAccount': 'Plano de Contas',
  'release.form.description': 'Descrição',
  'release.form.documentNumber': 'Número do Documento',
  'release.form.split': 'Parcela',
  'release.form.taxes': 'Tributos',
  'release.form.documentType': 'Tipo de Documento',
  'release.form.issueDate': 'Dt. Emissão',
  'release.form.dueDate': 'Dt. Vencimento',
  'release.form.payDay': 'Dt. Pagamento',
  'release.form.costCenter': 'Centro de Custo',
  'release.form.bankAccount': 'Conta Bancária',
  'release.form.value': '(R$) Valor',
  'release.form.increaseAndDecrease': '(R$) Acresc./Desc.',
  'release.form.supplierCredit': 'Crédito Fornecedor',
  'release.form.netValue': '(R$) Valor Líquido',
  'release.form.installmentBasis': 'Valor base da parcela',
  'release.form.observation': 'Observação',

  'release.form.button.renegotiate': 'Renegociar',
  'release.form.button.settleInstallment': 'Liquidar parcela',
  'release.form.button.partiallySettle': 'Liquidar parcialmente',
  'release.form.button.generateTicket': 'Gerar boleto',

  'release.modal.form.taxationData': 'Dados de Tributação',
  'release.modal.form.noteData': 'Dados da Nota',
  'release.modal.form.series': 'Série',
  'release.modal.form.model': 'Modelo',
  'release.modal.form.cfop': 'Cfop',
  'release.modal.form.amount': 'Valor Total',
  'release.modal.form.icms': 'ICMS',
  'release.modal.form.icmsAliquot': 'Aliquota ICMS',
  'release.modal.form.icmsValue': 'Valor ICMS',
  'release.modal.form.pis': 'PIS',
  'release.modal.form.pisAliquot': 'Aliquota PIS',
  'release.modal.form.pisValue': 'Valor PIS',
  'release.modal.form.cofins': 'COFINS',
  'release.modal.form.cofinsAliquot': 'Aliq. COFINS',
  'release.modal.form.cofinsValue': 'Valor COFINS',
};
